import React, {useEffect, useState} from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router'
import styled, { withTheme } from 'styled-components'
import { messages } from './messages'
import LanguageProvider from '../../containers/LanguageProvider/LanguageProvider'
import { slugify } from '../../helpers/utils'

const Wrapper = styled.div`
  height: 40px;
`
const ExpressNav = styled.div.attrs(props => ({
  id: props.id,
  className: 'animated fadeIn'
}))`
  font-size: 12px;
  background-color: var(--clr-main-to-black);
  box-shadow: 0 1px 2px rgba(19, 51, 61, 0.5);
  border-radius: var(--border-radius);
  padding: 0 1em;
  height: 40px; /* Menu height */
  overflow: hidden; /* Don't show anything outside the nav */

  ul {
    margin: 0;
    padding: 0;
    list-style-type: none;
    max-height: 80px; /* Menu height category 2 */
    position: relative; /* Position the menu button relative to this item */
  }

  li {
    display: inline-block;
  }

  a {
    cursor: pointer;
    display: inline-block;
    padding: 0 1em;
    color: var(--clr-nav-text);
    font-weight: 600;
    font-size: 1rem;
    letter-spacing: 0.06em;
    text-decoration: none;
    text-transform: uppercase;
    white-space: nowrap;
    line-height: 42px; /* Menu height */
    height: 40px; /* Menu height */
  }

  a:hover,
  a.nav-link.active-nav {
    background-color: rgba(255, 255, 255, 0.25);
  }

  li:last-child {
    /* The menu button */
    position: absolute; /* Move the menu button out of flow */
    right: -12px;
    bottom: 40px; /* Move upwards, the same distance as the menu height */
    background-image: linear-gradient(
      to right,
      rgba(19, 51, 61, 0) 0,
      var(--clr-main-to-black) 2em
    );
    padding-left: 3em;
  }

  li:nth-last-child(2) {
    /* The close button */
    display: none;
  }

  &.expanded {
    height: auto;
    padding: 0;
    position: absolute;
    right: 0;
    left: 0;
    z-index: 10;
  }

  &.expanded ul {
    max-height: none;
  }

  &.expanded li {
    display: block;
  }

  &.expanded a {
    display: block;
  }

  &.expanded a:hover,
  &.expanded a.nav-link.active-nav,
  a:focus {
    background-color: rgba(255, 255, 255, 0.25);
  }

  &.expanded li:not(:first-child) {
    margin-top: 2px;
  }

  &.expanded li:last-child {
    display: none;
  }

  &.expanded li:nth-last-child(2) {
    display: inline-block;
    position: absolute;
    top: 0;
    right: 0;
    margin: 0;
    border-left: 2px solid var(--clr-main-to-black);
  }
  .menu-toggle {
    a {
      background-color: rgba(255, 255, 255, 0.25);
      display: flex;
      align-items: center;
      border-top-left-radius: var(--button-border-radius);
      border-bottom-left-radius: var(--button-border-radius);
    }
    span {
      font-size: var(--small-icon-size);
      margin-right: 5px;
    }
    span + span {
      font-size: unset;
    }
  }
`

const PriorityScrollMenu = styled.div.attrs(props => ({
  id: props.id
}))`
  position: relative; /* change to "fixed" if you want a fixed menu bar */
  overflow: hidden;
  z-index: 10000;
  left: 0;
  top: 0;
  width: 100%;
  border-radius: var(--border-radius);
  box-shadow: 0 1px 2px rgba(19, 51, 61, 0.5);
  background: var(--clr-btn); /* background of menu strip */

  ul {
    margin: 0;
    padding: 0;
    display: flex;
    font-size: 12px;
    text-transform: uppercase;
    list-style-type: none;
    position: relative;
    min-width: 100%;
    z-index: 1000;
    -webkit-overflow-scrolling: touch;
    -webkit-transform: translateX(0);
    transform: translateX(0);
    -webkit-transition: -webkit-transform 1s;
    transition: transform 1s;
  }

  html.can-touch #priorityscroll ul {
    overflow: auto;
  }

  li {
    margin: 0;
    display: flex;
    flex: none;
    float: left; /* non flex browsers */
  }

  li a {
    display: block;
    position: relative;
    text-decoration: none;
    font-weight: 700;
    letter-spacing: 0.06em;
    padding: 0 1em; /*padding inside each link */
    color: var(--clr-black-to-main);
    outline: none;
    background: var(--clr-btn);
    -webkit-transition: all 0.5s;
    transition: all 0.5s;
    line-height: 42px;
    height: 40px;
  }

  li a:visited {
    color: white;
  }

  li a:hover,
  li a.nav-link.active-nav {
    //border-bottom: 8px solid rgba(0,0,0,.3);
    background-color: rgba(
      255,
      255,
      255,
      0.25
    ); /*background of UI links for hover state  */
  }

  html.can-touch #priorityscroll li a:hover {
    /* disable hover effect on touch screen input */
    background: inherit;
  }

  li input[type='text'] {
    /* sample CSS for form elements inside LI */
    background: #eee;
    border: 1px solid black;
    padding: 10px;
    line-height: 1.5em;
    padding-right: 5px;
    align-self: center;
    width: 170px;
  }

  /* ####### responsive layout CSS ####### */

  @media (max-width: 600px) {
    /* 2nd breaking point */

    a,
    li a {
      padding: 15px; /*padding inside each link */
    }
  }

  @media (max-width: 480px) {
    /* 3rd breaking point */
    a,
    li a {
      font-size: 1em;
    }
  }
`

const ExpressNavBar = ({
  expressCategories,
  query,
  expanded,
  onExpand,
  currentDevice,
  language,
  location,
  toggleDeviceModal
}) => {
  const translated = messages[language]
  const [activeExpressCategory, setActiveExpressCategory] = useState(-1);
  useEffect(() => {
    if (location.pathname.includes('expresshelp')) {
      if (location.state && location.state.categoryIndex !== null) {
        setActiveExpressCategory(location.state.categoryIndex)
      } else if (location.pathname === '/expresshelp') {
        setActiveExpressCategory(0)
      } else {
        const faqId = parseInt(location.pathname.match(/([0-9]+)/), 10)
        setActiveExpressCategory(
          expressCategories.findIndex(category =>
            category.children.find(subcat =>
              subcat.children.find(
                faq => parseInt(faq.pk, 10) === parseInt(faqId, 10)
              )
            )
          )
        )
      }
    }
  }, [location])

  return (
    <Wrapper>
      {true && expressCategories.length > 0 && (
        <ExpressNav id="menu" className={expanded ? 'expanded' : ''}>
          <ul id="menu-closed">
            {expressCategories.map((category, i) => (
              <li key={i}>
                {!category.acadLink || (category.acadLink && currentDevice) ? (
                  <Link
                    to={{
                      pathname: category.acadLink
                        ? '/devicehome'
                        : `/expresshelp/${slugify(category.name)}`,
                      state: { categoryIndex: i },
                      query
                    }}
                    className={`nav-link${
                      activeExpressCategory === i ||
                      (category.acadLink &&
                        location.pathname.includes('devicehome'))
                        ? ' active-nav'
                        : ''
                    }`}
                    // activeClassName="active-nav"
                    onClick={() => expanded && onExpand()}
                  >
                    {category.name}
                  </Link>
                ) : (
                  <a
                    href=""
                    className="nav-link"
                    onClick={() => !currentDevice && toggleDeviceModal()}
                  >
                    {category.name}
                  </a>
                )}
              </li>
            ))}
            <li className="menu-toggle">
              <a onClick={() => onExpand()}>
                <span>&#215;</span>
                <span>{translated.close}</span>
              </a>
            </li>
            <li className="menu-toggle">
              <a onClick={() => onExpand()}>
                <span>&#9776;</span>
                <span>{translated.more}</span>
              </a>
            </li>
          </ul>
        </ExpressNav>
      )}

      {false && expressCategories.length > 0 && (
        <PriorityScrollMenu id="priorityscroll">
          <ul>
            {expressCategories.map((category, i) => (
              <li key={i}>
                <Link
                  to={{
                    pathname: `/expresshelp/${category.children[0].children[0].pk}`,
                    query
                  }}
                  className="nav-link"
                  activeClassName="active-nav"
                >
                  {category.name}
                </Link>
              </li>
            ))}
          </ul>
        </PriorityScrollMenu>
      )}
    </Wrapper>
  )
}

ExpressNavBar.propTypes = {
  expressCategories: PropTypes.array.isRequired,
  query: PropTypes.object.isRequired,
  expanded: PropTypes.bool.isRequired,
  onExpand: PropTypes.func.isRequired,
  currentDevice: PropTypes.object,
  language: PropTypes.string.isRequired,
  location: PropTypes.object.isRequired,
  toggleDeviceModal: PropTypes.func
}

export default LanguageProvider(withTheme(ExpressNavBar))



// WEBPACK FOOTER //
// ./src/components/ExpressHelp/ExpressNavBar.js